import {
    doppeActionTypeCreateSettingsResolvingFunction,
    doppeActionTypeDefineMetadata
} from '../../client-server-common/doppe-action-types/doppe-action-type';
import {
    BymoPagePropsContentSettingSpecialSemanticMeaning,
    BymoPagePropsContentSettingType,
    bymoPagePropsCreateContentSettingMetadata
} from '../../client-server-common';

export namespace DoppeActionTypeNavigateButton {


    export interface ActionSettings {
        location: string;
        showContactPanel: boolean
    }
}

export const doppeActionTypeNavigateButton = doppeActionTypeDefineMetadata<DoppeActionTypeNavigateButton.ActionSettings>({
    id: 'io.bymo.action/navigate-button',
    resolveActionSettings: doppeActionTypeCreateSettingsResolvingFunction({
        location: '',
        showContactPanel: false,
    }),
    actionSettingsMetadata: {
        contentSettingsMetadata: {
            location: bymoPagePropsCreateContentSettingMetadata(BymoPagePropsContentSettingType.Text, BymoPagePropsContentSettingSpecialSemanticMeaning.Unspecified)
        },
        supportsActionCtaButtons: false,
        supportsContentSections: false,
        hideableContentSettingsNames: {}
    },
    actionListItemSettingsMetadata: false,
    isWidgetOpener: false,
    hasNoLockInnerCTA: true,
});
